import { useEffect } from 'react';
import { resolveAppKgobBase } from '@/lib/getYourAnswerApi';

export default function BookConsultationRedirect() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (!params.has('source')) params.set('source', 'kgob-site');
    window.location.replace(`${resolveAppKgobBase()}/book-consultation?${params.toString()}`);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F6F2]" data-testid="book-consultation-redirect">
      <p className="text-[#4C5A70] text-sm">Taking you to our booking page…</p>
    </div>
  );
}
